module.exports = __webpack_public_path__ + "static/suitz.c8711fb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/suitz.jpg
// module id = 470
// module chunks = 114276838955818